














import { Component, Prop, Vue } from 'vue-property-decorator'
import { Icon } from '@alpha/ink'
import DropdownButton from '@/components/DropdownButton.vue'
import { Route } from 'vue-router/types/router'
import { sharedViewRouteName } from '@/router'
import { Respondent } from '@/store/modules/survey-store-module'

@Component({
  components: {
    DropdownButton,
    Icon
  }
})
export default class OpenEnd extends Vue {
  @Prop({ required: true }) value!: string
  @Prop({ required: true }) respondent!: Respondent

  get respondentLink () {
    let base: Partial<Route> = { name: 'by-participant', hash: '#' + this.simpleId }
    if (this.$route.query.admin === 'true') {
      base = { ...base, query: { admin: 'true' } }
    }
    return base
  }

  get simpleId () {
    return this.respondent.simpleId
  }

  get publicView () {
    return this.$route.name === sharedViewRouteName
  }
}
